@if (isInitialized && component) {
  <oe-navigation-view>
    <ion-buttons header class="ion-justify-content-center">
      <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
      <pickdate *ngIf="!ref.children.length"></pickdate>
    </ion-buttons>
    @switch (componentType) {
      @case ('sum') {
        <oe-common-consumption-history-phase-accurate-chart
          [isOnlyChart]="true"></oe-common-consumption-history-phase-accurate-chart>
      }
      @case ('consumptionMeter') {
        <consumptionMeterChart [isOnlyChart]="true"></consumptionMeterChart>
      }
      @case ('evcs') {
        <evcsChart [isOnlyChart]="true"></evcsChart>
      }
      @case ('heat') {
        <heatChart [isOnlyChart]="true"></heatChart>
      }
    }
  </oe-navigation-view>
}
